import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	releases: {
		id: 'spa-apps-software-releases-version-detail.releases',
		defaultMessage: 'Releases',
		description: 'breadcrumb label that links to Releases home',
	},
});
